export default __webpack_public_path__ + "static/media/iconCard4.b0dcc3da.svg";